export const RED_CUTOFF = 200;
export const YELLOW_CUTOFF = 400;
